import { CSS_VARS } from '../constants';
import { getCssVar, getOwnerDomContext } from '../utils/helpers';

/**
 * Calculates the distance (in px) an element overflows the page (and gutter).
 * If left aligned, returns the overflow on the right side, and vice versa
 *
 * @param element element to test page overflow
 * @return object with the offset distance `value` in pixels, and the `side` of the page it's overflowing
 */
export default function calculateElementOverflow(element: HTMLElement | null) {
  const { ownerDoc } = getOwnerDomContext(element);
  const gutterRaw = getCssVar(CSS_VARS.GRID_GUTTER, ownerDoc);
  const gutter = isNaN(parseFloat(gutterRaw)) ? 0 : parseFloat(gutterRaw);
  const elementBCR = element?.getBoundingClientRect();

  if (!elementBCR) {
    return;
  }

  // overflowing left side of the page
  if (Math.round(elementBCR.left) < gutter) {
    return {
      value: gutter - Math.round(elementBCR.left),
      side: 'left',
    };
  }

  // overflowing right side of the page
  if (Math.round(elementBCR.right) > ownerDoc.documentElement.clientWidth - gutter) {
    return {
      value: Math.round(elementBCR.right) - (ownerDoc.documentElement.clientWidth - gutter),
      side: 'right',
    };
  }

  return {
    side: '',
    value: 0,
  };
}
